import { Box, useTheme } from "@mui/material";
import { PercentageDelta } from "web_myplann/Shared/Components/PercentageDelta";
import {
	DANGER_MYPLANN_LIGHT,
	DANGER_TERTIARY,
	GRASS_GREEN_MYPLANN,
	LIGHT_GREEN_MYPLANN,
} from "web_myplann/Utils/constants";

type EvaluationChipProps = {
	evaluation: number;
	isDashboardDetail?: boolean;
};

export const EvaluationChip = ({
	evaluation,
	isDashboardDetail,
}: EvaluationChipProps) => {
	const { palette } = useTheme();

	const isNearZero = Math.abs(evaluation) < 0.01;

	const bgColor = isNearZero
		? palette.deprecated.grey[400]
		: evaluation > 0
			? LIGHT_GREEN_MYPLANN
			: DANGER_TERTIARY;

	return (
		<Box
			position="absolute"
			sx={{ marginTop: isDashboardDetail ? "25px" : "15px" }}
			padding="4px"
			bgcolor={bgColor}
			borderRadius="9999px"
			zIndex={1}
		>
			<PercentageDelta
				change={isNearZero ? 0 : evaluation}
				fontSize={12}
				fontWeight={500}
				color={
					isNearZero
						? palette.darkmodeText.white
						: evaluation > 0
							? GRASS_GREEN_MYPLANN
							: DANGER_MYPLANN_LIGHT
				}
			/>
		</Box>
	);
};
